import { render } from "./TableSelection.vue?vue&type=template&id=052366ee&scoped=true&ts=true"
import script from "./TableSelection.vue?vue&type=script&lang=ts"
export * from "./TableSelection.vue?vue&type=script&lang=ts"

import "./TableSelection.vue?vue&type=style&index=0&id=052366ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052366ee"]])

export default __exports__